import { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { AuthShell } from '@/components/auth/AuthShell';

const API_URL = process.env.REACT_APP_API_URL || 'https://localhost:7001/api';

// Reads the magic-link token + email from the URL, then bounces the browser to the
// backend verify endpoint. That endpoint redirects back to /auth/callback with the
// JWT pair in the fragment.

export default function MagicLinkCallback() {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const email = params.get('email');

    if (!token || !email) {
      setError('Invalid magic link. Please request a new one.');
      return;
    }

    const verifyUrl = `${API_URL}/auth/magic-link/verify?token=${encodeURIComponent(token)}&email=${encodeURIComponent(email)}`;
    // Out of the address bar first, so nothing reporting this page as it
    // unloads (analytics) carries the token or the email.
    try { window.history.replaceState(null, '', window.location.pathname); } catch { /* no-op */ }
    window.location.href = verifyUrl;
  }, []);

  return (
    <AuthShell width="form">
      {error ? (
        <>
          <Alert variant="error">
            <AlertDescription>{error}</AlertDescription>
          </Alert>
          <p className="mt-3 text-center text-sm">
            <a href="/" className="text-primary hover:underline">Return to login</a>
          </p>
        </>
      ) : (
        <div className="text-center">
          <Loader2 className="mx-auto mb-2 h-8 w-8 animate-spin text-primary" />
          <p className="text-sm text-foreground">Verifying your magic link...</p>
        </div>
      )}
    </AuthShell>
  );
}
